function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import { StateHandler, controllerMixin, Messaging } from 'oskari-ui/util';
import { showSidePanel } from 'oskari-ui/components/window';
import { FORMAT_OPTIONS, PREVIEW_SCALED_WIDTH, UNSUPPORTED_FOR_CONFIGURED_SCALE } from './constants';
var UIHandler = /*#__PURE__*/function (_StateHandler) {
  function UIHandler(consumer, instance) {
    var _this;
    _classCallCheck(this, UIHandler);
    _this = _callSuper(this, UIHandler);
    _this.instance = instance;
    _this.sandbox = instance.getSandbox();
    _this.mapModule = _this.sandbox.findRegisteredModuleInstance('MainMapModule');
    _this.setState({
      size: 'A4',
      format: 'application/pdf',
      mapTitle: '',
      showScale: true,
      showDate: true,
      previewImage: null,
      scaleType: 'map',
      scale: null,
      showTimeSeriesDate: true,
      // impl for toggling coordinates is commented out in JSX. This will be enabled on future release.
      showCoordinates: false,
      coordinatePosition: 'center',
      coordinateProjection: 'map',
      isTimeSeries: false
    });
    _this.sidePanel = null;
    _this.eventHandlers = _this.createEventHandlers();
    _this.addStateListener(consumer);
    return _this;
  }
  _inherits(UIHandler, _StateHandler);
  return _createClass(UIHandler, [{
    key: "getName",
    value: function getName() {
      return this.instance.getName();
    }
  }, {
    key: "updatePanel",
    value: function updatePanel(title, content) {
      if (this.sidePanel) {
        this.sidePanel.update(title, content);
      }
    }
  }, {
    key: "showPanel",
    value: function showPanel(title, content, onClose) {
      if (!this.sidePanel) {
        this.sidePanel = showSidePanel(title, content, onClose);
      }
      if (this._isTimeSeriesActive()) {
        this.updateState({
          isTimeSeries: true
        });
      }
    }
  }, {
    key: "closePanel",
    value: function closePanel() {
      if (this.sidePanel) {
        this.sidePanel.close();
        this.sidePanel = null;
      }
    }
  }, {
    key: "updateField",
    value: function updateField(field, value) {
      this.updateState(_defineProperty({}, field, value));
      if (field === 'size') {
        this.refreshPreview(true);
      }
      if (field === 'scale') {
        this.mapModule.zoomToScale(value, false);
      }
    }
  }, {
    key: "updateScaleType",
    value: function updateScaleType(scaleType) {
      var scale = null;
      if (scaleType === 'configured') {
        // select closest value by current scale
        var mapScale = this.mapModule.getMapScale();
        var scales = this.instance.scaleOptions;
        scale = scales.reduce(function (prev, curr) {
          return Math.abs(curr - mapScale) < Math.abs(prev - mapScale) ? curr : prev;
        });
        this.mapModule.zoomToScale(scale, false);

        // notify user about ignored layers
        var unsupported = this._getVisibleLayers().filter(function (layer) {
          return UNSUPPORTED_FOR_CONFIGURED_SCALE.includes(layer.getLayerType());
        }).map(function (layer) {
          return layer.getName();
        });
        if (unsupported.length) {
          var msg = this.instance.loc('BasicView.scale.unsupportedLayersMessage');
          Messaging.warn({
            content: "".concat(msg, ": ").concat(unsupported.join(), "."),
            duration: 10
          });
        }
        // disable map zoom
        this.sandbox.postRequestByName('DisableMapKeyboardMovementRequest', [['zoom']]);
        this.sandbox.postRequestByName('DisableMapMouseMovementRequest', [['zoom']]);
      } else {
        this.sandbox.postRequestByName('EnableMapKeyboardMovementRequest', [['zoom']]);
        this.sandbox.postRequestByName('EnableMapMouseMovementRequest', [['zoom']]);
      }
      this.updateState({
        scaleType: scaleType,
        scale: scale
      });
    }
  }, {
    key: "refreshPreview",
    value: function refreshPreview() {
      var baseLayer = this.mapModule.getBaseLayer();
      this.updateState({
        previewImage: this.getUrlForPreview(baseLayer),
        baseLayerId: baseLayer === null || baseLayer === void 0 ? void 0 : baseLayer.getId()
      });
    }
  }, {
    key: "printMap",
    value: function printMap() {
      // ask for optimized link with non-visible layers excluded
      var optimized = true;
      var srs = this.sandbox.getMap().getSrsName();
      var maplinkArgs = this.sandbox.generateMapLinkParameters({
        srs: srs
      }, optimized);
      var params = this.gatherParamsFromState();
      var url = Oskari.urls.getRoute('GetPrint', params) + '&' + maplinkArgs;
      Oskari.log('BasicPrintout').debug('PRINT POST URL ' + url);
      var payload = {
        customStyles: this.getSelectedCustomStyles()
      };
      this.getPostPrint(url, params, payload);
    }
  }, {
    key: "_getResolution",
    value: function _getResolution() {
      if (this.instance.conf.scaleSelection && this.state.scaleType === 'configured') {
        this.mapModule.getExactResolution(this.state.scale);
      }
      return this.sandbox.getMap().getResolution();
    }
  }, {
    key: "_getVisibleLayers",
    value: function _getVisibleLayers() {
      // use same visibility filter as mapfull
      return this.sandbox.findAllSelectedMapLayers().filter(function (l) {
        return l.isVisibleOnMap();
      });
    }
  }, {
    key: "_getTopmostTimeseries",
    value: function _getTopmostTimeseries() {
      return this._getVisibleLayers().findLast(function (l) {
        return l.hasTimeseries();
      });
    }
  }, {
    key: "_isTimeSeriesActive",
    value: function _isTimeSeriesActive() {
      return !!this._getTopmostTimeseries();
    }
  }, {
    key: "_getTimeParam",
    value: function _getTimeParam() {
      var layer = this._getTopmostTimeseries();
      if (!layer) {
        return '';
      }
      return layer.getParams().time || '';
    }
  }, {
    key: "gatherParamsFromState",
    value: function gatherParamsFromState() {
      var params = {
        pageSize: this.state.size,
        format: this.state.format,
        resolution: this._getResolution(),
        pageTitle: this.state.mapTitle,
        pageScale: this.state.showScale,
        pageDate: this.state.showDate,
        pageTimeSeriesTime: this.state.showTimeSeriesDate,
        lang: Oskari.getLang(),
        coordinateSRS: this.mapModule.getProjection()
      };
      if (this.state.scale) {
        params.scaleText = '1:' + this.state.scale;
      }

      // check if other target crs setting beside default has been selected
      if (this.state.showCoordinates) {
        params.coordinateInfo = this.state.coordinatePosition;
        params.coordinateSRS = this.state.coordinateProjection === 'map' ? this.mapModule.getProjection() : this.state.coordinateProjection;
      }
      if (this.state.isTimeSeries) {
        var time = this._getTimeParam();
        params.time = time;
        if (this.state.showTimeSeriesDate) {
          var splittedTime = time.split('/')[0];
          params.formattedTime = Oskari.util.formatDate(splittedTime);
          params.timeseriesPrintLabel = this.instance.loc('BasicView.content.pageTimeSeriesTime.printLabel');
        }
      }
      return params;
    }

    /**
     * @private @method openPostPrint
     * Sends the gathered map data to the server to save them/publish the map.
     *
     * @param {String} printUrl
     * @param {Object} params
     * @param {Object} customStyles
     *
     */
  }, {
    key: "getPostPrint",
    value: function getPostPrint(printUrl, params, payload) {
      var _this2 = this;
      var fileName = params.pageTitle || 'print';
      var format = FORMAT_OPTIONS.find(function (format) {
        return format.mime === params.format;
      });
      if (format) {
        fileName += '.' + format.name;
      }
      this.updateState({
        loading: true
      });
      var successCb = function successCb(blob) {
        if (navigator.msSaveOrOpenBlob) {
          navigator.msSaveOrOpenBlob(blob, fileName);
        } else {
          var url = window.URL.createObjectURL(blob);
          var elem = document.createElement('a');
          elem.href = url;
          elem.download = fileName;
          document.body.appendChild(elem);
          elem.click();
          document.body.removeChild(elem);
          window.URL.revokeObjectURL(url);
        }
        _this2.updateState({
          loading: false
        });
      };
      var errorCb = function errorCb(error) {
        Oskari.log('BasicPrintout').error(error);
        _this2.updateState({
          loading: false
        });
        Messaging.error(Oskari.getMsg('Printout', 'BasicView.error.saveFailed'));
      };
      this.instance.getService().fetchPrint(printUrl, payload, successCb, errorCb);
    }
  }, {
    key: "getSelectedCustomStyles",
    value: function getSelectedCustomStyles() {
      var customStyles = {};
      this._getVisibleLayers().forEach(function (l) {
        var style = l.getCurrentStyle();
        if (typeof style.isRuntimeStyle === 'function' && style.isRuntimeStyle()) {
          customStyles[l.getId()] = style.getFeatureStyle();
        }
      });
      return customStyles;
    }
  }, {
    key: "getUrlForPreview",
    value: function getUrlForPreview(layer) {
      if (!layer) {
        return null;
      }
      var map = Oskari.getSandbox().getMap();
      var mapLayers = layer.getId() + ' ' + layer.getOpacity() + ' ' + layer.getCurrentStyle().getName();
      var params = {
        format: 'image/png',
        pageSize: this.state.size,
        resolution: this._getResolution(),
        srs: map.getSrsName(),
        coord: "".concat(map.getX(), "_").concat(map.getY()),
        mapLayers: mapLayers,
        scaledWidth: PREVIEW_SCALED_WIDTH,
        coordinateSRS: this.mapModule.getProjection()
      };
      if (layer.hasTimeseries()) {
        params.time = this._getTimeParam();
      }
      return Oskari.urls.getRoute('GetPrint', params);
    }
  }, {
    key: "createEventHandlers",
    value: function createEventHandlers() {
      var _this3 = this;
      var onLayerEvent = function onLayerEvent(event) {
        var layer = event.getMapLayer();
        var id = _this3.state.baseLayerId;
        if (!id || layer.getId() === id) {
          // only baselayer is shown in preview
          _this3.refreshPreview();
        }
        if (layer.hasTimeseries()) {
          _this3.updateState({
            isTimeSeries: _this3._isTimeSeriesActive()
          });
        }
      };
      var handlers = {
        MapLayerVisibilityChangedEvent: onLayerEvent,
        AfterMapMoveEvent: function AfterMapMoveEvent() {
          return _this3.refreshPreview();
        },
        AfterMapLayerAddEvent: onLayerEvent,
        AfterChangeMapLayerStyleEvent: onLayerEvent,
        AfterMapLayerRemoveEvent: function AfterMapLayerRemoveEvent(event) {
          if (event.getMapLayer().getId() === _this3.state.baseLayerId) {
            _this3.updateState({
              baseLayerId: null
            });
          }
        }
      };
      Object.getOwnPropertyNames(handlers).forEach(function (p) {
        return _this3.sandbox.registerForEventByName(_this3, p);
      });
      return handlers;
    }
  }, {
    key: "onEvent",
    value: function onEvent(e) {
      var handler = this.eventHandlers[e.getName()];
      if (!handler || !this.sidePanel) {
        return;
      }
      return handler.apply(this, [e]);
    }
  }]);
}(StateHandler);
var wrapped = controllerMixin(UIHandler, ['updateField', 'updateScaleType', 'printMap']);
export { wrapped as PrintoutHandler };